import React from "react";

import { BreadcrumbItem } from "./breadcrumb-item";
import { BreadcrumbItemData } from "./models";

import "./style.scss";

interface BreadcrumbProps {
  items: Array<BreadcrumbItemData>;
  onClick?: (data: BreadcrumbItemData, index: number) => void;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {

  return (
    <div className="breadcrumbs">
      {items.map((data, index) => (
        <BreadcrumbItem
          key={data.name}
          name={data.name}
          index={index}
          showArrow={index !== 0}
          active={items.length - 1 === index}
          onClick={() => data.onClick?.(index)}
        />
      ))}
    </div>
  );
};
